<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Assets'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <tidy-card-button (action)="goToCreateConciergeAction()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/csv.svg'"
              style="width:20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text
                [header]="'Upload Your Items'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Already have a list? Upload it.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card class="no-margin-bottom">
      <tidy-card-button (action)="goToUploadInventoryList()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/integrate.svg'"
              style="width:20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text
                [header]="'Start With Popular Items'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Start with the most popular items and add more as needed.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
